// extracted by mini-css-extract-plugin
export var paginationComponent = "B_b4";